import { take, select } from 'redux-saga/effects';
import { find } from 'lodash';

import { FinancialSituation, ReduxStoreData } from '@funnels/types';
import { REDUX_STORE } from '@funnels/constants';

export function* getFinancialSituationId(clientId: string, id?: string): any {
  if (!id) {
    const reduxStoreFinancialSituations: FinancialSituation[] = yield select(
      ({ financialSituations: { data } }: ReduxStoreData) => data
    );
    const financialSituation = find(reduxStoreFinancialSituations, { clientId });

    if (financialSituation && financialSituation.id) {
      return financialSituation.id;
    }
  }
  while (!id) {
    const action = yield take([
      REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.CREATE_FINANCIAL_SITUATION_FAIL,
      REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.CREATE_FINANCIAL_SITUATION_SUCCESS,
    ]);
    if (action.clientId === clientId) {
      // Create failed, return undefined
      if (action.type === REDUX_STORE.FINANCIAL_SITUATIONS.ACTION_TYPES.CREATE_FINANCIAL_SITUATION_FAIL) {
        return;
      }
      id = action.id;
    }
  }
  return id;
}
